import { getShellConfig } from '@src/config/shell/config';
import { getConfig } from '@superbet-group/web.lib.config';

export function getOddDisplayValue(
    name: string,
    showSpecialBetStatus: boolean,
    specialBetValue: string | null,
): string {
    let displayValue = name;

    if (showSpecialBetStatus && specialBetValue) {
        displayValue += ` (${specialBetValue})`;
    }

    return displayValue;
}

export function getOfferHost() {
    const shellConfig = getShellConfig();
    return `${shellConfig.remoteConfig.sportsOffer.host}/${shellConfig.localConfig.offerLocaleOverride || getConfig().appLocale.locale}`;
}

export function getOfferSseHost() {
    return `${getShellConfig().remoteConfig.sportsOffer.sseHost}/${getConfig().appLocale.locale}`;
}
